import React from "react";
import KeyValTable from "../Common/KeyValTable";

const Details = ({ data = {} }) => {
  return (
    <div>
      <h2>Details</h2>
      <KeyValTable data={data} />
    </div>
  );
};
export default Details;
